import { useMemo } from "react";
import useAppSelector from "@/core/helpers/useAppSelector";
import { tradeSelector } from "@/domains/inventory/slice";

export default function useTradeParticipants(currCharacterId: number) {
  const trade = useAppSelector(tradeSelector);
  const tradeParticipant = useMemo(() => {
    if (trade) {
      const characterIds = [trade.initiator, trade.recipient];
      return {
        self: characterIds.find((item) => item.characterId === currCharacterId),
        other: characterIds.find((item) => item.characterId !== currCharacterId),
      };
    }
    return {
      self: undefined,
      other: undefined,
    };
  }, [trade, currCharacterId]);

  return { trade, tradeParticipant };
}
